export * from './IdCardIcon';
export * from './IdCardIcon16Light';
export * from './IdCardIcon16Regular';
export * from './IdCardIcon16Solid';
export * from './IdCardIcon20Light';
export * from './IdCardIcon20Regular';
export * from './IdCardIcon20Solid';
export * from './IdCardIcon24Regular';
export * from './IdCardIcon24Solid';
export * from './IdCardIcon32Regular';
export * from './IdCardIcon64Regular';
